export default __webpack_public_path__ + "static/media/front1.5e72d5eb.webp";